


export class ViewLPU {
  "Identificador";
  "Projeto";
  "Faturamento_70_30";
  "Data";
  "DescricaoAtividade";
  "CodigoServico";
  "NomeFornecedor";
  "FornecedorNomeFantasia";
  "Vendor";
  "Tecnologia";
  "SiglaEstado";
  "NomeEstado";
  "Regiao";
  "Localidade";
  "Valor100Contratado";
  "Valor70";
  "Valor30";
  "Observacoes";
  "Buyer";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewLPU`.
   */
  static getModelName() {
    return "ViewLPU";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewLPU for dynamic purposes.
  **/
  static factory(data) {
    return new ViewLPU(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ViewLPU',
      plural: 'ViewLPUs',
      path: 'ViewLPUs',
      properties: {
        "Identificador": {
          name: 'Identificador',
          type: 'number'
        },
        "Projeto": {
          name: 'Projeto',
          type: 'string'
        },
        "Faturamento_70_30": {
          name: 'Faturamento_70_30',
          type: 'string'
        },
        "Data": {
          name: 'Data',
          type: 'Date'
        },
        "DescricaoAtividade": {
          name: 'DescricaoAtividade',
          type: 'string'
        },
        "CodigoServico": {
          name: 'CodigoServico',
          type: 'string'
        },
        "NomeFornecedor": {
          name: 'NomeFornecedor',
          type: 'string'
        },
        "FornecedorNomeFantasia": {
          name: 'FornecedorNomeFantasia',
          type: 'string'
        },
        "Vendor": {
          name: 'Vendor',
          type: 'string'
        },
        "Tecnologia": {
          name: 'Tecnologia',
          type: 'string'
        },
        "SiglaEstado": {
          name: 'SiglaEstado',
          type: 'string'
        },
        "NomeEstado": {
          name: 'NomeEstado',
          type: 'string'
        },
        "Regiao": {
          name: 'Regiao',
          type: 'string'
        },
        "Localidade": {
          name: 'Localidade',
          type: 'string'
        },
        "Valor100Contratado": {
          name: 'Valor100Contratado',
          type: 'number'
        },
        "Valor70": {
          name: 'Valor70',
          type: 'number'
        },
        "Valor30": {
          name: 'Valor30',
          type: 'number'
        },
        "Observacoes": {
          name: 'Observacoes',
          type: 'string'
        },
        "Buyer": {
          name: 'Buyer',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ViewLPU.js